<template>
  <el-dialog title="订单退货退款" :visible.sync="dialogVisible" width="500px" append-to-body :fullscreen="device==='mobile'" @close="dialogClose">
    <el-form v-if="refundInfo" ref="refundForm" :model="refundInfo" :rules="rules" label-width="100px">
      <el-form-item label="订单编号">{{ refundInfo.orderNumber }}</el-form-item>
      <el-form-item label="支付单号">{{ refundInfo.payNumber }}</el-form-item>
      <el-form-item label="退货原因" prop="reasonId">
        <el-select v-model="refundInfo.reasonId" class="max-width" filterable clearable placeholder="请选择退货原因">
          <el-option v-for="(item, index) in refundReasons" :key="index" :label="item.explanation" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item label="退款说明" prop="remark">
        <el-input v-model="refundInfo.remark" class="max-width" placeholder="请输入退款说明" clearable />
      </el-form-item>
    </el-form>

    <template v-slot:footer>
      <el-button @click="handleCancel">取　消</el-button>
      <el-button type="primary" @click="handleSubmit">确定提交</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { getRefundReasonList, refundApply } from '@/api/order'

export default {
  emits: ['refresh'],
  props: {
    show: Boolean,
    order: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      refundInfo: {},
      dialogVisible: false,
      refundReasons: [],
      rules: {
        reasonId: [{ required: true, message: '请选择退货原因', trigger: 'change' }],
        remark: [{ required: true, message: '请输入退款说明', trigger: 'blur' }]
      }
    }
  },
  computed: mapGetters(['device']),
  watch: {
    show: {
      immediate: true,
      handler(value) {
        this.dialogVisible = value
      }
    },
    order: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.refundInfo = Object.assign({}, newValue)
      }
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      getRefundReasonList().then(response => {
        this.refundReasons = response
      }).catch(() => {})
    },
    dialogClose() {
      this.dialogVisible = false
      this.$emit('update:show', false)
    },
    handleCancel() {
      this.dialogClose()
    },
    handleSubmit() {
      this.$refs.refundForm.validate((valid) => {
        if (!valid) return false

        refundApply(this.refundInfo).then(bool => {
          if (bool) {
            this.refundInfo.orderStatus = 13
            this.refundInfo.orderStatusName = '退款中'
            this.$emit('update:order', this.refundInfo)
            this.$emit('refresh')
            this.dialogClose()
          }
        }).catch(() => {})
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .max-width {
    max-width: 90%;
  }
  .mobile {
    .max-width {
      max-width: 100%;
    }
  }
  .el-select-dropdown__item {
    display: flex;
    justify-content: space-between;
  }
</style>
